import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import OldPersonnelProfileLayout from './OldPersonnelProfileLayout';

import CreatableSelect from 'react-select/creatable';

// import utility file
import { Alert, Button, Card, Col, Form, Row } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';

import PersonnelService from '../../services/PersonnelService';

const ViewOldPersonnel = () => {
	const { id } = useParams();
	const [personnel, setPersonnel] = useState(null);
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');
	const [personnelData, setPersonnelData] = useState({});
	const [selectedPoste, setSelectedPoste] = useState('');
	const [selectedGenre, setSelectedGenre] = useState('');

	const GENRE_CHOICES = [
		{ value: 'm', label: 'Masculin' },
		{ value: 'f', label: 'Feminin' }
	];

	const POSTE_CHOICES = [
		{ value: 'enseignant', label: 'Enseignant(e)' },
		{ value: 'enseignant_principal', label: 'Enseignant Principal' },
		{ value: 'surveillant_general', label: 'Surveillant Général' },
		{ value: 'conseiller_pedagogique', label: 'Conseiller Pédagogique' },
		{ value: 'infirmier', label: 'Infirmier' },
		{ value: 'bibliothecaire', label: 'Bibliothécaire' },
		{ value: 'technicien_informatique', label: 'Technicien Informatique' },
		{ value: 'agent_de_service', label: 'Agent de Service' },
		{ value: 'gardien', label: 'Gardien' },
		{ value: 'chauffeur', label: 'Chauffeur' },
		{ value: 'cantine', label: 'Responsable de la Cantine' },
		{ value: 'psychologue_scolaire', label: 'Psychologue Scolaire' },
		{ value: 'educateur_specialise', label: 'Éducateur Spécialisé' },
		{ value: 'assistant_pedagogique', label: 'Assistant Pédagogique' },
		{ value: 'assistant_administratif', label: 'Assistant Administratif' }
	];

	useEffect(() => {
		Promise.all([PersonnelService.getPersonnel(id)]).then(([personnelData]) => {
			setPersonnel(personnelData.data);

			if (personnelData && personnelData.data) {
				const personnelPoste = personnelData.data.poste;
				const posteOption = POSTE_CHOICES.find(
					(option) => option.value === personnelPoste
				);
				setSelectedPoste(posteOption ? posteOption : '');

				const personnelGenre = personnelData.data.genre;
				const genreOption = GENRE_CHOICES.find(
					(option) => option.value === personnelGenre
				);
				setSelectedGenre(genreOption ? genreOption : '');
			}
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const formData = new FormData();

				// Add all your form data to the FormData
				formData.append('nom', form.nom.value);
				formData.append('prenom', form.prenom.value);
				formData.append('adresse', form.adresse.value);
				formData.append('telephone', form.telephone.value);
				formData.append('email', form.email.value);
				formData.append('date_naissance', form.date_naissance.value);

				// Get the files from the component state instead of the form
				if (personnelData.photo && personnelData.photo.file) {
					formData.append('photo', personnelData.photo.file);
				}

				formData.append('genre', form.genre.value);
				formData.append('poste', form.poste.value);
				formData.append('diplome', form.diplome.value);

				// Get the files from the component state instead of the form
				if (personnelData.cv && personnelData.cv.file) {
					formData.append('cv', personnelData.cv.file);
				}

				formData.append(
					'date_affiliation_cnps',
					form.date_affiliation_cnps.value
				);
				formData.append('annees_experience', form.annees_experience.value);
				formData.append('deduction_cnps', form.deduction_cnps.value);
				formData.append('cotisation_cnps', form.cotisation_cnps.value);

				// Call the PersonnelService to create the personnel
				// Call the EleveService to create the eleve
				const response = await PersonnelService.updatePersonnel(id, formData);

				// Reset the form and state variables after successful update
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Add this line to refresh the page
				window.location.reload();
			} catch (error) {
				console.error('Erreur lors de la mise à jour des informations du personnel', error);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<OldPersonnelProfileLayout>
			{personnel && (
				<>
					<Card className="mb-3 ">
						{/* Card body */}
						<Card.Body>
							{/*  Form  */}
							<Form
								className="mb-2 disableClick"
								noValidate
								validated={validated}
								onSubmit={handleSubmit}
							>
								{showAlert && (
									<Alert variant="danger">
										<ExclamationTriangleFill size={25} className="me-1" />
										{alertMessage}
									</Alert>
								)}
								<Row>
									<Col xs={12} className="mb-2">
										{/* Nom et prenom  */}
										<Form.Group className="mb-2">
											<Row>
												<Col md={6} sm={12} className="mb-2">
													<Form.Label htmlFor="nom">
														Nom <span className="text-danger">*</span>
													</Form.Label>
													<Form.Control
														name="nom"
														type="text"
														placeholder="Saisir le nom du personnel"
														id="nom"
														required
														isInvalid={!!feedbackMessages['nom']}
														onChange={(e) => {
															setFeedbackMessages((prevMessages) => ({
																...prevMessages,
																nom: e.target.value ? '' : 'Le nom est requis.'
															}));
														}}
														defaultValue={personnel.nom}
													/>
													<Form.Control.Feedback type="invalid">
														{feedbackMessages['nom']}
													</Form.Control.Feedback>
												</Col>
												<Col md={6} sm={12} className="mb-2">
													<Form.Label htmlFor="prenom">
														Prénom <span className="text-danger">*</span>
													</Form.Label>
													<Form.Control
														name="prenom"
														type="text"
														placeholder="Saisir le prénom du personnel"
														id="prenom"
														required
														isInvalid={!!feedbackMessages['prenom']}
														onChange={(e) => {
															setFeedbackMessages((prevMessages) => ({
																...prevMessages,
																prenom: e.target.value
																	? ''
																	: 'Le prénom est requis.'
															}));
														}}
														defaultValue={personnel.prenom}
													/>
													<Form.Control.Feedback type="invalid">
														{feedbackMessages['prenom']}
													</Form.Control.Feedback>
												</Col>
											</Row>
										</Form.Group>
									</Col>

									{/* Genre et date de naissance */}
									<Col xs={12} className="mb-2">
										<Form.Group className="mb-2">
											<Row>
												<Col md={6} sm={12} className="mb-2">
													<Form.Label>
														Date de Naissance{' '}
														<span className="text-danger">*</span>
													</Form.Label>
													<Form.Control
														name="date_naissance"
														type="date"
														placeholder="Selectionner la date de naissance"
														id="date_naissance"
														defaultValue={personnel.date_naissance}
														required
														isInvalid={!!feedbackMessages['date_naissance']}
														onChange={(e) => {
															const value = e.target.value;
															const feedbackMessage = value
																? ''
																: 'La date de naissance est requise.';
														}}
													/>
													<Form.Control.Feedback type="invalid">
														{feedbackMessages['date_naissance']}
													</Form.Control.Feedback>
												</Col>

												<Col md={6} sm={12} className="mb-2">
													<Form.Label htmlFor="genre">
														Genre <span className="text-danger">*</span>
													</Form.Label>
													<Form.Select
														name="genre"
														required
														defaultValue={selectedGenre}
														isInvalid={!!feedbackMessages['genre']}
														onChange={(e) => {
															setFeedbackMessages((prevMessages) => ({
																...prevMessages,
																genre: e.target.value
																	? ''
																	: 'La genre du personnel est requis.'
															}));
														}}
													>
														{GENRE_CHOICES.map((option, index) => (
															<option key={index} value={option.value}>
																{option.label}
															</option>
														))}
													</Form.Select>
													<Form.Control.Feedback type="invalid">
														{feedbackMessages['genre']}
													</Form.Control.Feedback>
												</Col>
											</Row>
										</Form.Group>
									</Col>

									{/* Adresse */}
									<Col xs={12} className="mb-2">
										<Form.Group className="mb-2">
											<Form.Label htmlFor="adresse">
												Adresse <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												name="adresse"
												type="text"
												placeholder="Saisir le l'adresse du personnel"
												id="adresse"
												required
												isInvalid={!!feedbackMessages['adresse']}
												onChange={(e) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														adresse: e.target.value
															? ''
															: "L'adresse est requise."
													}));
												}}
												defaultValue={personnel.adresse}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['adresse']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									<Col xs={12} className="mb-2">
										{/* Téléphone et email  */}
										<Form.Group className="mb-2">
											<Row>
												<Col md={6} sm={12} className="mb-2">
													<Form.Label htmlFor="telephone">
														Téléphone <span className="text-danger">*</span>
													</Form.Label>
													<Form.Control
														name="telephone"
														type="number"
														placeholder="Saisir le téléphone du personnel"
														id="telephone"
														required
														isInvalid={!!feedbackMessages['telephone']}
														onChange={(e) => {
															setFeedbackMessages((prevMessages) => ({
																...prevMessages,
																telephone: e.target.value
																	? ''
																	: 'Le numéro de téléphone est requis.'
															}));
														}}
														defaultValue={personnel.telephone}
													/>
													<Form.Control.Feedback type="invalid">
														{feedbackMessages['telephone']}
													</Form.Control.Feedback>
												</Col>
												<Col md={6} sm={12} className="mb-2">
													<Form.Label htmlFor="email">Email</Form.Label>
													<Form.Control
														name="email"
														type="email"
														placeholder="nom@example.com"
														id="email"
														isInvalid={!!feedbackMessages['email']}
														onChange={(e) => {
															setFeedbackMessages((prevMessages) => ({
																...prevMessages,
																email: e.target.value
																	? ''
																	: "L'adresse saisie n'est pas valide."
															}));
														}}
														defaultValue={personnel.email}
													/>
													<Form.Control.Feedback type="invalid">
														{feedbackMessages['email']}
													</Form.Control.Feedback>
												</Col>
											</Row>
										</Form.Group>
									</Col>

									{/* Dernier diplôme */}
									<Col xs={12} className="mb-2">
										<Form.Group className="mb-2">
											<Form.Label htmlFor="diplome">
												Dernier diplôme <span className="text-danger">*</span>
											</Form.Label>
											<Form.Control
												name="diplome"
												type="text"
												placeholder="Saisir le nom dernier diplôme obtenu"
												id="diplome"
												required
												isInvalid={!!feedbackMessages['diplome']}
												onChange={(e) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														diplome: e.target.value
															? ''
															: 'Le nom du dernier diplôme est requis.'
													}));
												}}
												defaultValue={personnel.diplome}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['diplome']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* Date affiliation CNPS */}
									<Col xs={12} className="mb-2">
										<Form.Group className="mb-2">
											<Form.Label htmlFor="date_affiliation_cnps">
												Date affiliation CNPS
											</Form.Label>
											<Form.Control
												name="date_affiliation_cnps"
												type="date"
												placeholder="Selectionner la date d'affiliation à la CNPS"
												id="date_affiliation_cnps"
												defaultValue={personnel.date_affiliation_cnps}
												isInvalid={!!feedbackMessages['date_affiliation_cnps']}
												onChange={(e) => {
													const value = e.target.value;
													const feedbackMessage = value
														? ''
														: "La date d'affiliation à la CNPS n'est pas valide.";
												}}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['date_affiliation_cnps']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* Poste */}
									<Col xs={12} className="mb-2">
										<Form.Group className="mb-2">
											<Form.Label htmlFor="poste">
												Poste <span className="text-danger">*</span>
											</Form.Label>
											<CreatableSelect
												isClearable
												placeholder="Selectionner le poste de ce personnel"
												options={POSTE_CHOICES}
												name="poste"
												required
												defaultValue={selectedPoste}
												isInvalid={!!feedbackMessages['poste']}
												onChange={(selectedOption) => {
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														poste: selectedOption
															? ''
															: 'Le poste de ce personnel est requis.'
													}));
												}}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['poste']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* Années d'expérience */}
									<Col xs={12} className="mb-2">
										<Form.Group className="mb-2">
											<Form.Label>Années d'expérience</Form.Label>
											<Form.Control
												name="annees_experience"
												type="number"
												min="0"
												placeholder="Saisir le nombre d'années d'expérience"
												id="annees_experience"
												isInvalid={!!feedbackMessages['annees_experience']}
												onChange={(e) => {
													const value = e.target.value;
													const feedbackMessage = value
														? ''
														: "Le nombre d'années d'expérience n'est pas valide.";
												}}
												defaultValue={personnel.annees_experience}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['annees_experience']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* Déduction et cotisation CNPS */}
									<Col xs={12} className="mb-2">
										<Form.Group className="mb-2">
											<Row>
												<Col md={6} sm={12} className="mb-2">
													<Form.Label>Déduction CNPS</Form.Label>
													<Form.Control
														name="deduction_cnps"
														type="number"
														min="0"
														step="0.01"
														placeholder="Saisir le montant déduit"
														id="deduction_cnps"
														isInvalid={!!feedbackMessages['deduction_cnps']}
														onChange={(e) => {
															const value = e.target.value;
															const feedbackMessage = value
																? ''
																: "La valeur saisie n'est pas valide.";
														}}
														defaultValue={personnel.deduction_cnps}
													/>
													<Form.Control.Feedback type="invalid">
														{feedbackMessages['deduction_cnps']}
													</Form.Control.Feedback>
												</Col>

												<Col md={6} sm={12} className="mb-2">
													<Form.Label>Cotisation CNPS</Form.Label>
													<Form.Control
														name="cotisation_cnps"
														type="number"
														min="0"
														step="0.01"
														placeholder="Saisir le montant de la cotisée"
														id="cotisation_cnps"
														isInvalid={!!feedbackMessages['cotisation_cnps']}
														onChange={(e) => {
															const value = e.target.value;
															const feedbackMessage = value
																? ''
																: "La valeur saisie n'est pas valide.";
														}}
														defaultValue={personnel.cotisation_cnps}
													/>
													<Form.Control.Feedback type="invalid">
														{feedbackMessages['cotisation_cnps']}
													</Form.Control.Feedback>
												</Col>
											</Row>
										</Form.Group>
									</Col>

									{/* Photo */}
									<Col xs={12} className="mb-2">
										<Form.Group className="mb-2">
											<Form.Label htmlFor="photo">Photo de profil</Form.Label>
											<Form.Control
												name="photo"
												type="file"
												placeholder="Selectionner la photo de profil du personnel"
												id="photo"
												accept="image/*"
												isInvalid={!!feedbackMessages['photo']}
												// for photo
												onChange={(e) => {
													const file = e.target.files[0];
													const isValidFile =
														file && file.type.startsWith('image/');
													const feedbackMessage = isValidFile
														? ''
														: "Le fichier sélectionné n'est pas une image.";

													// Update feedbackMessages
													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														photo: feedbackMessage
													}));

													if (isValidFile) {
														// Convert the file to a blob URL and pass it to the parent component
														const fileURL = URL.createObjectURL(file);

														// assuming personnelData is your state object
														setPersonnelData((prevData) => ({
															...prevData,
															photo: { file, fileURL }
														}));
													}
												}}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['photo']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* CV */}
									<Col xs={12} className="mb-4">
										<Form.Group className="mb-2">
											<Form.Label htmlFor="cv">CV</Form.Label>
											<Form.Control
												name="cv"
												type="file"
												placeholder="Selectionner la cv du personnel"
												id="cv"
												accept="application/pdf, image/*"
												isInvalid={!!feedbackMessages['cv']}
												onChange={(e) => {
													const file = e.target.files[0];
													const isValidFile =
														file &&
														(file.type === 'application/pdf' ||
															file.type.startsWith('image/'));
													const feedbackMessage = isValidFile
														? ''
														: "Le fichier sélectionné n'est pas une image ou un fichier PDF.";

													setFeedbackMessages((prevMessages) => ({
														...prevMessages,
														cv: feedbackMessage
													}));

													if (isValidFile) {
														// Convert the file to a blob URL and pass it to the parent component
														const fileURL = URL.createObjectURL(file);

														// assuming personnelData is your state object
														setPersonnelData((prevData) => ({
															...prevData,
															cv: { file, fileURL }
														}));
													}
												}}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['cv']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>

									{/* Date affiliation CNPS */}
									<Col xs={12} className="mb-2">
										<Form.Group className="mb-2">
											<Form.Label htmlFor="date_cessation_emploi">
												Date cessation emploi
											</Form.Label>
											<Form.Control
												name="date_cessation_emploi"
												type="date"
												placeholder="Selectionner la date de cessation d'emploi"
												id="date_cessation_emploi"
												defaultValue={personnel.date_cessation_emploi}
												isInvalid={!!feedbackMessages['date_cessation_emploi']}
												onChange={(e) => {
													const value = e.target.value;
													const feedbackMessage = value
														? ''
														: "La date de cessation d'emploi n'est pas valide.";
												}}
											/>
											<Form.Control.Feedback type="invalid">
												{feedbackMessages['date_cessation_emploi']}
											</Form.Control.Feedback>
										</Form.Group>
									</Col>
								</Row>
							</Form>
						</Card.Body>
					</Card>
				</>
			)}
		</OldPersonnelProfileLayout>
	);
};

export default ViewOldPersonnel;
